import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './TermsItem.module.css';

import { ControllerRenderProps } from 'react-hook-form';

import useModal from '../../../../hooks/useModal';

import { RegisteredName, SignupForm } from '../../../../types/login';
import { Terms } from '../../../../types/common';

import { isOfType } from '../../../../utils/typeGuard';
import { VIEW } from '../../../../constants';
import { Agreement } from '../../../../types/membership';
import { settingsApiSlice } from '../../../../services/settings';

interface TermsItem {
  field: ControllerRenderProps<SignupForm, `agreeCdList.${number}`>;
  data: Terms | Agreement;
  setValue: (name: RegisteredName, value: string) => void;
  checked: boolean;
}

export default function TermsItem({
  field,
  data,
  setValue,
  checked,
}: TermsItem) {
  const cx = classNames.bind(styles);
  const [isCheck, setIsCheck] = useState(false);
  const { toggleModal } = useModal();

  const [getTermsInfo] = settingsApiSlice.useLazyGetTermsQuery();

  const setChangedValue = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const value =
      isOfType<HTMLInputElement>(target, 'checked') && target.checked
        ? data.agreeCd
        : '';
    setValue(field.name, value);
    setIsCheck(target.checked);
  };

  const openViewTerms = async () => {
    const name = data.agreeCd === 'T0101' ? 'terms' : 'privacyPolicy';
    let res;

    if (!('content' in data)) {
      try {
        res = await getTermsInfo(data.agreeCd);
        console.log('res : ', res);
      } catch (error) {
        console.error('Failed to Get Terms', error);
      }
    }

    toggleModal({
      name,
      id: data.agreeCd,
      type: 'content',
      data: 'content' in data ? data : res?.data,
    });
  };

  useEffect(() => {
    setIsCheck(checked);
  }, [checked]);

  return (
    <li>
      <label>
        <input
          type="checkbox"
          className={cx('blind')}
          onChange={setChangedValue}
          checked={isCheck}
          required={'requireYn' in data ? !!data.requireYn : true}
        />
        <span className={cx('clabel')}>{data.dispTitle}</span>
      </label>

      {data.agreeCd && data.agreeCd !== 'T0199' && (
        <div className={cx('btn', 'link_t')} onClick={openViewTerms}>
          <span>{VIEW}</span>
        </div>
      )}
    </li>
  );
}
